<script>
import IconComponent from './Icon.vue'

let uuid = 0

export default {
    // state
    data () {
        return {
            id: uuid++,
            hidden: true,
        }
    },
    props: {
        from: {
            default: 'left',
            type: String,
        },
        isFullWidth: {
            default: true,
            type: Boolean,
        },
        label: {
            default: 'Select an Option',
            type: String,
        },
        labelIsHidden: {
            default: false,
            type: Boolean,
        },
        options: {
            required: true,
            type: Array,
        },
        toggleText: {
            default: 'toggle menu',
            type: String,
        },
        value: {
            default: null,
        },
    },
    computed: {
        selectedOption () {
            return this.options.find(option => option.value === this.value)
        },
    },
    methods: {
        select (option) {
            this.$emit('select', { detail: option })
        },
        documentClick ($event) {
            if (this.$el.contains($event.target)) return
            this.hide()
        },
        hide () {
            this.hidden = true
        },
        toggle () {
            this.hidden = !this.hidden
        },
    },
    // lifecycle
    mounted () {
        document.addEventListener('click', this.documentClick)
    },
    unmounted () {
        document.removeEventListener('click', this.documentClick)
    },
    // misc.
    components: {
        Icon: IconComponent,
    },
}
</script>

<template>
    <div
        class="tw:relative"
        v-bind:class="{
            'tw:flex': !isFullWidth,
            'tw:items-center': !isFullWidth,
        }"
        v-on:click="toggle"
    >
        <label
            class="tw:relative"
            v-text="label"
            v-bind:class="{
                'tw:fixed': labelIsHidden,
                'tw:left-[-9999em]': labelIsHidden,
            }"
            v-bind:for="'vca_vue_dropdown_toggle_' + id"
        ></label>
        <button
            aria-haspopup="true"
            class="
                tw:block
                tw:absolute
                tw:inset-0
                tw:indent-[-9999em]
                tw:bg-[rgba(255,0,0,0)]
                tw:border-none
            "
            type="button"
            v-text="toggleText"
            v-on:click="toggle"
            v-bind:aria-expanded="!hidden"
            v-bind:for="'vca_vue_dropdown_toggle_' + id"
        ></button>
        <div
            class="
                tw:relative
                tw:flex
                tw:justify-between
                tw:items-center
                tw:px-4
                tw:py-2
                tw:space-x-2
                tw:bg-white
                tw:border
                tw:border-solid
                tw:border-ccc
                tw:cursor-pointer
            "
            v-bind:class="{
                'tw:mt-2': !labelIsHidden && isFullWidth,
                'tw:ml-2': !labelIsHidden && !isFullWidth,
            }"
        >
            <span roll="status" v-text="selectedOption.display"></span>
            <Icon
                aria-hidden="true"
                class="tw:ml-2 tw:fill-vacatia-blue tw:transition-all"
                v-bind:class="{ 'tw:rotate-180': !hidden }"
                v-bind:icon="'arrow'"
            />
        </div>
        <div
            class="
                tw:absolute
                tw:top-full
                tw:z-50
                tw:py-2
                tw:mt-1
                tw:w-48
                tw:min-w-full
                tw:bg-white
                tw:border
                tw:border-solid
                tw:border-ccc
            "
            role="menu"
            v-bind:class="{
                'tw:left-0': from === 'left',
                'tw:right-0': from === 'right',
            }"
            v-bind:hidden="hidden ? '' : null"
        >
            <button
                class="
                    tw:block
                    tw:px-4
                    tw:py-2
                    tw:w-full
                    tw:text-left
                    tw:bg-transparent
                    tw:border-0
                "
                type="button"
                v-text="option.display"
                v-for="option in options"
                v-on:click="select(option)"
                v-bind:class="{
                    'tw:text-ccc': option.value === value,
                    'tw:hover:text-white': option.value !== value,
                    'tw:hover:bg-vacatia-blue': option.value !== value,
                    'tw:hover:cursor-default': option.value === value,
                }"
            ></button>
        </div>
    </div>
</template>
